import type { SrFaceDecision, SrFacePhoto, VoterPhotoUploaded } from "./sr-face-check-types";
import { getPhotoLink } from "./sr-face-check-types";

const existingPhotoFromVoter = (
    voter: Record<string, unknown> | null | undefined,
    photos?: SrFacePhoto[]
): string => {
    if (!voter) return "";
    const fromProfile =
        String(voter.profile_photo || (voter.profile as any)?.profile_photo || "") ||
        getPhotoLink((voter as any).latest_photo) ||
        getPhotoLink(photos?.[0]);
    return fromProfile;
};

/** Stamp the photo that should be saved on the subject onto the matched voter. */
export const voterWithSubjectPhoto = (
    voter: Record<string, unknown>,
    photoUrl: string
): Record<string, unknown> => {
    const profile = (voter.profile as Record<string, unknown>) || {};
    return {
        ...voter,
        profile_photo: photoUrl,
        profile: { ...profile, profile_photo: photoUrl },
    };
};

/**
 * replace → save the new (updated) capture
 * keep → keep the voter's existing photo on the subject
 */
export const resolveUploadedPhoto = (
    result: VoterPhotoUploaded | string
): { photoUrl: string; voter: Record<string, unknown> | null } => {
    if (typeof result === "string") {
        return { photoUrl: result, voter: null };
    }

    const voter = result.voter && Object.keys(result.voter).length > 0 ? result.voter : null;
    const decision: SrFaceDecision | undefined = result.decision;

    const photoUrl =
        decision === "keep"
            ? existingPhotoFromVoter(voter, result.photos) || result.photoUrl
            : result.photoUrl;

    return {
        photoUrl,
        voter: voter ? voterWithSubjectPhoto(voter, photoUrl) : null,
    };
};
